"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.default = void 0;
var BillboardDefault = {
  primarySubtitleLinkColor: 'inherit',
  primarySubtitleLinkColorHover: 'initial',
  secondarySubtitleLinkColor: 'primary',
  secondarySubtitleLinkColorHover: 'primary',
  subtitleFontSize: 'medium',
  columnWidth: [12, null, 12, 12],
  background: 'accent2',
  primaryColor: 'offblack',
  secondaryColor: 'primary',
  backgroundSecondary: 'offwhite',
  btnVariant: 'primary',
  secondaryBtnVariant: 'secondary',
  primarySubtitleLinkDecoration: 'underline',
  secondarySubtitleLinkDecoration: 'underline'
};
var Billboard = {
  horizon: _objectSpread(_objectSpread({}, BillboardDefault), {}, {
    primarySubtitleLinkColor: 'black',
    primarySubtitleLinkColorHover: 'black'
  }),
  cannesLions: _objectSpread(_objectSpread({}, BillboardDefault), {}, {
    background: 'accent1',
    primaryColor: 'white',
    primarySubtitleLinkColor: 'white',
    primarySubtitleLinkColorHover: 'white'
  }),
  lionsLive: _objectSpread(_objectSpread({}, BillboardDefault), {}, {
    background: 'accent1',
    primarySubtitleLinkColor: 'primary',
    primarySubtitleLinkColorHover: 'primary'
  }),
  money2020: _objectSpread(_objectSpread({}, BillboardDefault), {}, {
    background: 'accent2',
    secondarySubtitleLinkColor: 'inherit',
    secondarySubtitleLinkColorHover: 'initial'
  }),
  spikes: _objectSpread(_objectSpread({}, BillboardDefault), {}, {
    primarySubtitleLinkColor: 'white',
    primarySubtitleLinkColorHover: 'white'
  }),
  ascential: _objectSpread(_objectSpread({}, BillboardDefault), {}, {
    background: 'primary',
    primaryColor: 'accent1',
    primarySubtitleLinkColor: 'white',
    primarySubtitleLinkColorHover: 'white'
  }),
  dcl: _objectSpread(_objectSpread({}, BillboardDefault), {}, {
    primaryColor: 'white',
    primarySubtitleLinkColor: 'white',
    primarySubtitleLinkColorHover: 'white'
  }),
  lionsCreativity: _objectSpread(_objectSpread({}, BillboardDefault), {}, {
    background: 'accent5',
    primaryColor: 'white',
    backgroundSecondary: 'white',
    subtitleFontSize: 'small',
    btnVariant: 'secondary',
    secondaryBtnVariant: 'primary',
    primarySubtitleLinkColor: 'white',
    primarySubtitleLinkColorHover: 'white'
  })
};
var _default = Billboard;
exports.default = _default;